import { TitleButton } from '@/common/buttons/TitleButton';
import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { GridConstants } from '@/common/grid/GridConstants';
import { useNavState } from '@/common/navState/NavStateContext';
import { usePrincipal } from '@/common/principal/PrincipalContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useRef, useState } from 'react';

export const PolList = () => {

  const { hasRole } = usePrincipal();
  const { navigateTo } = useNavState();
  const rsrc = useRsrc();

  const [isCompareDisabled, setIsCompareDisabled] = useState(true);

  const entityListRef = useRef();

  const handleSelectionChanged = (event) => {
    const selectedRows = event.api.getSelectedRows();
    if (selectedRows.length !== 2) {
      setIsCompareDisabled(true);
      return;
    }

    const [first, second] = selectedRows;
    const firstCode = first.type;
    const secondCode = second.type;
    setIsCompareDisabled(!(firstCode && firstCode === secondCode));
  }

  const augFieldDefs = (fieldToFieldDef) => {
    fieldToFieldDef.checkbox = GridConstants.checkbox;
  };

  const getContextMenuItems = (params) => {
    let contextMenuItems = entityListRef.current.getContextMenuItems(params);

    if (hasRole('GP_POL_SAVE')) {
      contextMenuItems.push({
        name: 'Clone Policy',
        action: () => rsrc.clone('gp','POL',params.node.data.id),
        icon: '<span class = "fa fa-pencil"></span>'
      })
    }

    const multipleSelected = params.api.getSelectedRows().length > 1
    if (multipleSelected) {
      contextMenuItems = contextMenuItems.map(item => ({ ...item, disabled: true }));
    }
    
    return contextMenuItems;
  }

  const navigateToPolFormulaCompare = () => {
    const gridApi = entityListRef.current.gridRef.current.gridApiRef.current;

    const selectedPols = gridApi.getSelectedRows();
    navigateTo('gp/compare/pol-formula', { pols: selectedPols })
  }

  const navigateToIncDataSrcCompare = () => {
    const gridApi = entityListRef.current.gridRef.current.gridApiRef.current;

    const selectedPols = gridApi.getSelectedRows();
    navigateTo('gp/compare/inc-data-src', { pols: selectedPols })
  }

  const augButtons = (buttons) => {
    buttons.push(
      <TitleButton key="comparePolFormulaButton" icon={fas.faFunction} disabled={isCompareDisabled} toolTip="Compare Formulas between two Policies" onClick={navigateToPolFormulaCompare}/>,
      <TitleButton key="compareIncDataSrcButton" icon={fas.faFilter} disabled={isCompareDisabled} toolTip="Compare Inclusion Data Sources between two Policies" onClick={navigateToIncDataSrcCompare}/>
    )
  };

  return (
    <EntityList
      ref={entityListRef}
      augButtons={augButtons}
      augFieldDefs={augFieldDefs}
      gridOptions={{
        rowSelection: 'multiple',
        getContextMenuItems
      }}
      events={{
        onSelectionChanged: handleSelectionChanged
      }}
    />
  )
}